// @ts-strict-ignore
import React from 'react'
import { Icon, Button, Card } from '../../../atoms'

interface Action {
  text: string
  description: string
  links: Array<{ text: string; href: string }>
}
interface Answer {
  text: string
  nextQuestion?: Question
  action: Action
}

interface Question {
  id: number
  question: string
  answers: Array<Answer>
  description: string
}
interface TriageDetails {
  questions: Question
  message: string
}

interface TriageProps {
  jsonBody: TriageDetails
  name: string
  sys: {
    id?: string
  }
  rawName: string
  variant: string
}

const Triage: React.FC<TriageProps> = ({ jsonBody, name, sys, rawName, variant }) => {
  try {
    const { questions, message } = jsonBody

    const { question, description, answers, id } = questions
    return (
      <div className='TriageWrapper'>
        <Card variant='plum'>
          <section
            data-name={name}
            data-triage='triage'
            data-triage-component-id={sys?.id}
            data-triage-contentful-name={rawName}
            className='Triage'
          >
            {message && (
              <div className='Triage__message'>
                <Icon glyph={'stop-watch'} size={24} />
                <h2 className='Triage__message__text'>{message}</h2>
              </div>
            )}
            <section data-triage='question' data-triage-id-value={id} className='Triage__qa'>
              <h3 className='Triage__qa__question'>{question}</h3>
              {description && <div className='Triage__qa__description'>{description}</div>}
              {answers && answers.length > 0 && (
                <ul className='Triage__qa__answers'>
                  {answers.map(({ text, nextQuestion, action }, index) => (
                    <li
                      key={index}
                      className='Triage__qa__answers__answer'
                      data-triage-nextq={JSON.stringify(nextQuestion)}
                      data-triage-action={JSON.stringify(action)}
                      data-triage-qid={id}
                      data-action='answer'
                    >
                      <Button
                        variant='secondary'
                        size='mdTriage'
                        withIcon={false}
                        /* eslint-disable camelcase */
                        dataClickTracking={JSON.stringify({
                          component_category: 'platinum-component',
                          component_id: sys?.id,
                          component_name: 'Triage',
                          contentful_name: rawName,
                          contentful_variant: variant,
                          additionalProps: { question: question, answer: text },
                        })}
                      >
                        {text}
                      </Button>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </section>
        </Card>
      </div>
    )
  } catch (error) {
    return <>Error</>
  }
}

export default Triage
